import { useIntl } from 'react-intl';

export const getID = (url: string): string => {
  const regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url.match(regExp);

  if (match && match[2].length === 11) {
    return match[2];
  }

  return '';
};

export const getEmbedUrl = (id: string): string => `https://www.youtube-nocookie.com/embed/${id}`;

export const getEmbedProps = () => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const intl = useIntl();
  const { locale } = intl;

  return `cc_locale_pref=${locale}&hl=${locale}&modestbranding=1&rel=0`;
};

export const getEmbedAttributes = (): object => {
  return {
    allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share',
    allowFullScreen: true,
    frameBorder: '0',
    referrerPolicy: 'strict-origin-when-cross-origin',
  };
};

interface GetEmbedSrcProps {
  url: string;
}

export const getEmbedSrc = ({ url }: GetEmbedSrcProps) => {
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  const baseUrl = `${getEmbedUrl(getID(url))}?${getEmbedProps()}&controls=1&autoplay=0`;
  return origin ? `${baseUrl}&origin=${encodeURIComponent(origin)}` : baseUrl;
};

interface GetEmbedIframeProps extends GetEmbedSrcProps {
  url: string;
  title?: string;
}

export const getEmbedIframe = ({ url, title = '' }: GetEmbedIframeProps) => {
  return <iframe title={title || ''} src={getEmbedSrc({ url })} {...getEmbedAttributes()} />;
};
